import { CreditCard, ISSUERS } from "@/data/schemas";

export function cardCountsTowards524(card: CreditCard): boolean {
  return (
    card.countsTowards524 ??
    (!card.isBusiness ||
      (card.issuer === ISSUERS.CAPITAL_ONE && card.isBusiness))
  );
}
